import { render, staticRenderFns } from "./InvitationItem.vue?vue&type=template&id=121ab0e4&scoped=true&"
import script from "./InvitationItem.vue?vue&type=script&lang=js&"
export * from "./InvitationItem.vue?vue&type=script&lang=js&"
import style0 from "./InvitationItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InvitationItem.vue?vue&type=style&index=1&id=121ab0e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121ab0e4",
  null
  
)

export default component.exports